module.exports = "/images/amex.svg?15ee430b648a361a566a925818a1b160";